import { Components, Theme } from "@mui/material/styles";

export const MuiTableHead = (theme: Theme) =>
  ({
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.light,
          boxShadow: theme.palette.tables.tableHead.shadow,
        },
      },
    },
  }) satisfies Components<Theme>;
